import { createReducer } from 'utils/redux'

const defaultState = {}
const setPlaybook = ({ action }) => action.playbook
const setPlaybookName = ({ draft, action }) => {
  draft.name = action.name
}
const setPlaybookStatus = ({ draft, action }) => {
  draft.status = action.status
}

const actions = {
  RECEIVE_PLAYBOOK: setPlaybook,
  RECEIVE_PLAYBOOK_NAME: setPlaybookName,
  RECEIVE_PLAYBOOK_STATUS: setPlaybookStatus,
}

const playbookReducer = createReducer(defaultState, actions)

export default playbookReducer
